import React, { useRef, useEffect, useCallback, useState} from 'react';
import {TAG} from './constants.js';
import {getSoundResultsServer} from './getSoundResults.js';
import {connect} from 'react-redux';
import ListResults from "components/selector2/ListResults.js";

const SourceToSearch = ({
    showPianoRoll,
    bottomHeight,
    sourceToSearch,
    setPackToSearch,
    sequencerEngine,
    guildId
}) => { 
    let ref = useRef(undefined);
    let [results, setResults] = useState([]);
    useEffect(() => {
        getSoundResultsServer(
            50, "", guildId, TAG, 0, false, sourceToSearch)
            .then((r) => {
                if (r.length > 0) {
                    setResults(r);
                } else {
                    // THERES A BUG IN BACKEND WHERE IT SOMETIMES RETURNS 0
                    // NON_DETERMINISTICALLY (I NO, BAD!). BUT SEARCHING AGAINN
                    // USUALLY FIXES IT
                    setTimeout(() => {
                        getSoundResultsServer(
                            50,
                            "", guildId, TAG, 0, false, sourceToSearch)
                            .then(setResults);
                    }, 500);
                }
            });
    }, [sourceToSearch, setResults]);

    let style = {
        height: window.innerHeight - 263
    };

    if (showPianoRoll) {
        style.height -= bottomHeight - 150;
    }

    return (
        <div ref={ref} style={style} className="source-to-search-results">
          <ListResults
            setPackToSearch={setPackToSearch}
            scrollRef={ref}
            sourceToSearch={sourceToSearch}
            size={1000}
            searchTerm={""}
            results={results}
            sequencerEngine={sequencerEngine}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      bottomHeight: state.arrangement.bottomHeight,
      guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceToSearch);
